module.exports = __webpack_public_path__ + "static/media/ManuelCorreaZavala.52243527.png";